module.exports = __webpack_public_path__ + "img/scissors_small_stripes.7146ed00.png";